export const holidays = [
  { name: "Independence Day", date: "2025-08-15", emoji: "🎆" },
  { name: "Vinayaka Chavithi", date: "2025-08-28", emoji: "🐘" },
  { name: "Vijaya Dashami & Mahatma Gandhi Jayanti", date: "2025-10-02", emoji: "🏹" },
  { name: "Deepavali", date: "2025-10-20", emoji: "🪔" },
  { name: "Christmas", date: "2025-12-25", emoji: "🎄" },
];

export const getNotifiedHoliday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // normalize time

  for (const holiday of holidays) {
    const hDate = new Date(holiday.date);
    hDate.setHours(0, 0, 0, 0); // normalize time

    const diffInDays = Math.floor((hDate - today) / (1000 * 60 * 60 * 24));

    if (diffInDays === 0) {
      return { ...holiday, type: "today" }; // today is holiday
    }
    if (diffInDays === 1 || diffInDays === 2) {
      return { ...holiday, type: "upcoming" }; // within 2 days
    }
  }

  return null; // no upcoming holiday
};
